import { useState } from "react";
import { signUp } from "../../services/supabase-auth.service";

export function SignupPanel({
	onSuccess,
	onSwitchToLogin,
}: {
	onSuccess: () => void;
	onSwitchToLogin: () => void;
}) {
	const [firstName, setFirstName] = useState("");
	const [lastName, setLastName] = useState("");
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [error, setError] = useState("");
	const [loading, setLoading] = useState(false);

	async function submit(e: React.FormEvent) {
		e.preventDefault();
		setError("");
		setLoading(true);
		try {
			const { user } = await signUp(email, password, {
				first_name: firstName,
				last_name: lastName,
			});
			// If email confirmation required, user exists but session is null — show message
			if (!user) throw new Error("Không thể tạo tài khoản.");
			onSuccess();
		} catch (err) {
			setError(err instanceof Error ? err.message : "Đăng ký thất bại.");
		} finally {
			setLoading(false);
		}
	}

	return (
		<div className="auth-card">
			<span className="brand-mark">G</span>
			<p className="eyebrow">Gout Food Scanner</p>
			<h1>Tạo tài khoản</h1>
			<p>Miễn phí. Chỉ cần email và mật khẩu để bắt đầu.</p>
			{error && (
				<div className="error" role="alert">
					{error}
				</div>
			)}
			<form onSubmit={submit} className="auth-form">
				<label className="auth-field">
					Tên
					<input
						value={firstName}
						onChange={(e) => setFirstName(e.target.value)}
						type="text"
						placeholder="Minh"
						autoComplete="given-name"
					/>
				</label>
				<label className="auth-field">
					Họ
					<input
						value={lastName}
						onChange={(e) => setLastName(e.target.value)}
						type="text"
						placeholder="Nguyễn"
						autoComplete="family-name"
					/>
				</label>
				<label className="auth-field">
					Email
					<input
						value={email}
						onChange={(e) => setEmail(e.target.value)}
						type="email"
						placeholder="ban@example.com"
						autoComplete="email"
						required
					/>
				</label>
				<label className="auth-field">
					Mật khẩu
					<input
						value={password}
						onChange={(e) => setPassword(e.target.value)}
						type="password"
						placeholder="Tối thiểu 8 ký tự"
						autoComplete="new-password"
						minLength={8}
						required
					/>
				</label>
				<button type="submit" className="primary auth-button" disabled={loading}>
					{loading ? "Đang tạo…" : "Tạo tài khoản"}
				</button>
			</form>
			<button type="button" className="auth-switch" onClick={onSwitchToLogin}>
				Đã có tài khoản? Đăng nhập
			</button>
		</div>
	);
}
